var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/* eslint-disable @typescript-eslint/no-explicit-any */
import { useState, useEffect } from 'react';
import { IMaskMixin } from 'react-imask';
import { TextFieldMessageStyled, TextFieldWrapperStyled, TextFieldStyled, TextFieldLabelWrapperStyled, ContentStyled, } from './styled';
import Icon from '../Icon';
const MaskedStyledInput = IMaskMixin((_a) => {
    var { inputRef } = _a, props = __rest(_a, ["inputRef"]);
    return (_jsx(TextFieldStyled, Object.assign({}, props, { ref: inputRef })));
});
const TextField = (_a) => {
    var props = __rest(_a, []);
    const { definition: definitionProp, disabled, endAdornment, fullWidth, helperText: helperTextProp, helperType: helperTypeProp, label, required, startAdornment, onChange: onChangeProp, onFieldClick: onFieldClickProp, onKeyDown: onKeyDownProp, onlyLabel, value: valueProp, type, readOnly, placeholder, mask: maskProp, maskValue: maskValueProp, style } = props, rest = __rest(props, ["definition", "disabled", "endAdornment", "fullWidth", "helperText", "helperType", "label", "required", "startAdornment", "onChange", "onFieldClick", "onKeyDown", "onlyLabel", "value", "type", "readOnly", "placeholder", "mask", "maskValue", "style"]);
    const [value, setValue] = useState(valueProp || '');
    const helperText = disabled && (helperTextProp === null || helperTextProp === undefined)
        ? 'Este campo no puede editarse'
        : helperTextProp;
    const helperType = disabled && !helperTypeProp ? 'disabled' : helperTypeProp;
    const handleChange = (event) => {
        if (onChangeProp) {
            onChangeProp(event.target.value);
        }
        setValue(event.target.value);
    };
    const handleClick = (event) => {
        if (!disabled && onFieldClickProp)
            onFieldClickProp(event);
    };
    const handleChangeMask = (mask, currentValue) => {
        const { _unmaskedValue: unmaskedValue } = mask;
        if (onChangeProp) {
            onChangeProp(maskValueProp ? currentValue : unmaskedValue);
        }
        setValue(currentValue);
    };
    const handleKeyDown = (event) => {
        if (onKeyDownProp)
            onKeyDownProp(event, event.key);
    };
    const iconProps = () => {
        switch (helperType) {
            case 'error':
                return { name: 'errorOutlined', color: '#F65940' };
            case 'warning':
                return { name: 'warningOutlined', color: '#FBC832' };
            case 'success':
                return { name: 'checkCircleOutlined', color: '#95D31C' };
            default:
                return { name: 'notInterestedOutlined', color: '#5B5D71' };
        }
    };
    useEffect(() => {
        setValue(valueProp || '');
    }, [valueProp]);
    return (_jsxs(TextFieldWrapperStyled, Object.assign({ disabled: disabled, fullWidth: fullWidth, style: Object.assign({}, style) }, rest, { children: [label && (_jsxs(TextFieldLabelWrapperStyled, Object.assign({ disabled: disabled }, { children: [_jsx("p", Object.assign({ style: Object.assign({ margin: 0 }, (value && !disabled ? { color: '#0057B8' } : {})) }, { children: label })), !onlyLabel && (_jsx("p", Object.assign({ style: Object.assign({ margin: 0 }, (value && !disabled ? { color: '#0057B8' } : {})) }, { children: required ? 'Obligatorio' : 'Opcional' })))] }))), _jsxs(ContentStyled, Object.assign({ value: value, disabled: disabled, helperText: helperText, helperType: helperType, startAdornment: startAdornment, endAdornment: endAdornment }, { children: [startAdornment, maskProp ? (_jsx(MaskedStyledInput, { disabled: disabled, definitions: definitionProp, placeholder: placeholder, readOnly: readOnly, type: type, value: value, mask: maskProp, radix: ".", onClick: handleClick, onKeyDown: handleKeyDown, onAccept: (maskedValue, mask) => handleChangeMask(mask, maskedValue) })) : (_jsx(TextFieldStyled, { disabled: disabled, placeholder: placeholder, readOnly: readOnly, type: type, mask: maskProp, value: value, onChange: handleChange, onKeyDown: handleKeyDown, onClick: handleClick })), endAdornment] })), helperText && (_jsxs(TextFieldMessageStyled, Object.assign({ disabled: disabled, helperType: helperType }, { children: [_jsx(Icon, Object.assign({}, iconProps())), helperText] })))] })));
};
TextField.defaultProps = {
    mask: '',
    maskValue: false,
    onKeyDown: () => { },
};
export default TextField;
//# sourceMappingURL=index.js.map